<template>
    <div>
        <el-form ref="form" :inline="true" :model="query" class="query-form" size="mini" @submit.native.prevent="onSubmit">

            <el-form-item label="ID：" class="query-form-item">
                <el-input v-model="query.id" placeholder="请输入ID"></el-input>
            </el-form-item>

            <el-form-item label="ASIN：" class="query-form-item">
                <el-input style="width: 150px;" clearable v-model="query.asin" placeholder="请输入ASIN"
                          size="mini"></el-input>
            </el-form-item>
            <el-form-item label="海关编码：" class="query-form-item">
                <el-input v-model="query.customs_code" placeholder="请输入海关编码"></el-input>
            </el-form-item>
            <el-form-item label="是否有图片：" class="query-form-item">
                <el-select v-model="query.has_img_url" placeholder="请选择" size="mini">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="有" :value="1"></el-option>
                    <el-option label="没有" :value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否有价格：" class="query-form-item">
                <el-select v-model="query.has_price" placeholder="请选择" size="mini">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="有" :value="1"></el-option>
                    <el-option label="没有" :value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                <el-button type="primary" icon="search" @click="onSubmit" native-type="submit">查询</el-button>
                <el-button type="success" @click.native="handleForm(null,null)">新增</el-button>
                <el-button type="success" @click.native="batchImportFunc()">批量新增</el-button>
                <el-button type="warning" @click.native="exportFunc()">无图导出</el-button>
            </el-form-item>
        </el-form>
        <el-table v-loading="loading" :data="list" :height="tableHeight" stripe border style="width: 100%">

            <el-table-column
                label="ID"
                prop="id"
                align="center"
                width="80px">
            </el-table-column>

            <el-table-column label="图片" width="120" align="center">
                <template slot-scope="scope">
                    <div v-if="!scope.row.img_url">暂无图片</div>
                    <img style="width:90px;height:90px;" :src="scope.row.img_url" v-else/>
                </template>
            </el-table-column>
            <el-table-column label="Asin" width="140" align="center">
                <template slot-scope="scope">
                    <div>
                        <span>{{ scope.row.asin }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                label="产品名称"
                align="center"
                prop="product_name"
                width="160px"
            >
            </el-table-column>

            <el-table-column
                label="海关编码(义乌)"
                align="center"
                prop="customs_code"
                width="160px"
            >
            </el-table-column>
            <el-table-column
                label="海关编码(盈和)"
                align="center"
                prop="customs_code_yh"
                width="160px"
            >
            </el-table-column>
            <el-table-column
                label="重"
                align="center"
                prop="weight"
                width="100px">
            </el-table-column>
            <el-table-column
                label="单价"
                align="center"
                prop="price"
                width="130px">
            </el-table-column>
            <el-table-column
                label="品牌"
                align="center"
                prop="brand"
                width="200px">
            </el-table-column>
            <el-table-column
                label="材质"
                align="center"
                prop="material"
                width="160px"
            >
            </el-table-column>
            <el-table-column
                label="材质（中文）"
                align="center"
                width="160px"
                prop="material_cn"
            >
            </el-table-column>
            <el-table-column
                label="用途"
                align="center"
                prop="purpose"
                width="160px"
            >
            </el-table-column>
            <el-table-column
                label="用途（中文）"
                align="center"
                prop="purpose_cn"
                width="160px"
                >
            </el-table-column>
            <el-table-column
                label="操作"
                width="330"
                align="center"
                fixed="right">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click.native="refreshImg(scope.$index, scope.row)">刷新图片
                    </el-button>
                    <el-button type="primary" size="mini" @click.native="refreshPrice(scope.$index, scope.row)">刷新价格
                    </el-button>
                    <el-button type="success" size="mini" @click.native="handleForm(scope.$index, scope.row)">编辑
                    </el-button>
                    <el-button type="danger" size="mini" @click.native="handleDel(scope.$index, scope.row)">删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            background
            :page-size="query.limit"
            style="float: right;margin-top: 20px; margin-bottom: 22px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="query.page"
            :total="total">
        </el-pagination>

        <!--表单-->
        <el-dialog
            v-if="formVisible"
            :title="formMap[formName]"
            :visible.sync="formVisible"
            :before-close="hideForm"
            width="600px"
            top="5vh">
            <el-form :model="formData" :rules="formRules" ref="dataForm" label-width="130px">
                <el-form-item label="国家" prop="state">
                    <el-select v-model="formData.state" style="width: 150px;" size="mini">
                        <el-option
                            v-for="item in $common.us_arr"
                            :key="item.us"
                            :label="item.title"
                            :value="item.us"
                            :disabled="item.disabled">
                            <div class="keywords_arr_div">
                                <icon-svg :icon-class="item.us.toUpperCase()"
                                          style="font-size: 24px;margin-right:5px;"></icon-svg>
                                <span
                                    style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{ item.title }}</span>
                            </div>
                        </el-option>
                    </el-select>
                </el-form-item>


                <el-form-item label="Asin">
                    <el-input v-model="formData.asin" placeholder="请输入Asin" auto-complete="off"
                              style="width: 300px;" :disabled="this.formName == 'edit'"></el-input>
                </el-form-item>

                <el-form-item label="产品名称">
                    <el-input v-model="formData.product_name" placeholder="请输入产品名称" auto-complete="off"
                              style="width: 300px;"></el-input>
                </el-form-item>

                <el-form-item label="海关编码(义乌)">
                    <el-input v-model="formData.customs_code" class="" placeholder="请输入海关编码(义乌)"
                              auto-complete="off"
                              style="width: 300px; "></el-input>
                </el-form-item>
                <el-form-item label="海关编码(盈和)">
                    <el-input v-model="formData.customs_code_yh" class="" placeholder="请输入海关编码(盈和)"
                              auto-complete="off"
                              style="width: 300px; "></el-input>
                </el-form-item>
                <el-form-item label="重">
                    <el-input v-model="formData.weight" class="" placeholder="请输入重" auto-complete="off"
                              style="width: 300px; "></el-input>
                </el-form-item>

                <el-form-item label="单价">
                    <el-input-number
                        v-model="formData.price"
                        style="width: 300px;"
                        :min="0.00"
                        :step="0.01"
                        size="mini"
                        placeholder="请输入单价"
                    >
                    </el-input-number>
                </el-form-item>

                <el-form-item label="品牌">
                    <el-input v-model="formData.brand" class="" placeholder="请输入品牌" auto-complete="off"
                              style="width: 300px; "></el-input>
                </el-form-item>

                <el-form-item label="材质">
                    <el-input v-model="formData.material" class="" placeholder="请输入材质" auto-complete="off"
                              style="width: 300px; "></el-input>
                </el-form-item>
                <el-form-item label="材质(中文)">
                    <el-input v-model="formData.material_cn" class="" placeholder="请输入材质(中文)" auto-complete="off"
                              style="width: 300px; "></el-input>
                </el-form-item>

                <el-form-item label="用途">
                    <el-input v-model="formData.purpose" class="" placeholder="请输入用途" auto-complete="off"
                              style="width: 300px; "></el-input>
                </el-form-item>
                <el-form-item label="用途(中文)">
                    <el-input v-model="formData.purpose_cn" class="" placeholder="请输入用途(中文)" auto-complete="off"
                              style="width: 300px; "></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideForm" size="mini">取消</el-button>
                <el-button type="primary" @click.native="formSubmit()" :loading="formLoading" size="mini">提交
                </el-button>
            </div>
        </el-dialog>
        <uploadDom :visible="addSubLibraryModal" @close-callback="closeCllback"
                   title="上传"/>
    </div>
</template>
<script>
import {
    logistics_asin_index,
    logistics_asin_add,
    logistics_asin_edit,
    logistics_asin_deleted,
    logistics_asin_fresh_img_url, logistics_asin_fresh_price,
} from '@/api/advAnalys/advAnalys.js'
import * as api from '@/api/advAnalys/advAnalys'
import {downloadFileUrl} from '@/utils/method'
import uploadDom from './compon/upload.vue'

const formJson = {
    state: '',
    product_name: '',
    customs_code: '',
    customs_code_yh: '',
    weight: '',
    price: '',
    brand: '无',
    material: '',
    material_cn: '',
    purpose: '',
    purpose_cn: '',
}
export default {
    components: {uploadDom},
    data() {
        return {
            tableHeight: null,
            query: {
                id: '',
                asin: '',
                customs_code: '',
                has_img_url: '',
                has_price: '',
                page: 1,
                limit: 20,
            },
            list: [],
            total: 0,
            loading: true,
            addSubLibraryModal: false,
            index: null,
            formName: null,
            formMap: {
                add: '新增发票Asin',
                edit: '编辑发票Asin'
            },
            formLoading: false,
            formVisible: false,
            formData: formJson,
            formRules: {},
            addRules: {
                state: [
                    {required: true, message: '请选择收件国家', trigger: 'blur'}
                ]
            },
            editRules: {},
            deleteLoading: false
        }
    },
    methods: {
        closeCllback(refresh) {
            this.addSubLibraryModal = false
            refresh && this.getList()
        },
        onReset() {
            this.query = {
                id: '',
                customs_code: '',
                asin: '',
                page: 1,
                limit: 20,
                role_id: '',
                total: 0
            }
            this.getList()
        },
        onSubmit() {
            this.query.page = 1
            this.getList()
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.getList()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.getList()
        },
        getList() {
            this.loading = true
            logistics_asin_index(this.query)
                .then(response => {
                    this.loading = false
                    this.list = response.data.list || []
                    this.total = response.data.total || 0
                })
                .catch(() => {
                    this.loading = false
                    this.list = []
                    this.total = 0
                })
        },
        // 刷新表单
        resetForm() {
            if (this.$refs['dataForm']) {
                // 清空验证信息表单
                this.$refs['dataForm'].clearValidate()
                // 刷新表单
                this.$refs['dataForm'].resetFields()
            }
        },
        // 隐藏表单
        hideForm() {
            // 更改值
            this.formVisible = !this.formVisible
            // 清空表单
            this.$refs['dataForm'].resetFields()
            this.initFormData()
            return true
        },
        initFormData() {
            this.formData = {
                id: '',
                state: '',
                product_name: '',
                customs_code: '',
                customs_code_yh: '',
                weight: '',
                price: '',
                brand: '无',
                material: '',
                material_cn: '',
                purpose: '',
                purpose_cn: '',
            }
        },
        // 显示表单
        handleForm(index, row) {
            this.formVisible = true
            if (row !== null) {
                this.formData = Object.assign({}, row)
            }
            this.formName = 'add'
            this.formRules = this.addRules
            if (index !== null) {
                this.index = index
                this.formName = 'edit'
                this.formRules = this.editRules
            }
        },
        exportFunc() {
            api.logistics_asin_export().then(res => {
                if (!res.success) {
                    this.$message({type: 'error', message: res.message})
                    return
                }
                this.downFile(res.data)
            }).catch(res => {
                this.$message({type: 'error', message: res.message})
            })
        },
        batchImportFunc() {
            this.addSubLibraryModal = true

        },
        downFile(path) {
            if (!path) {
                return this.$message({
                    type: 'error',
                    message: '无法下载！'
                })
            }
            downloadFileUrl(path)
        },
        refreshImg(index, rowData) {
            logistics_asin_fresh_img_url({id: rowData.id}).then(res => {
                this.loading = false
                if (res.code === 0) {
                    this.getList()
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        refreshPrice(index, rowData) {
            logistics_asin_fresh_price({id: rowData.id}).then(res => {
                this.loading = false
                if (res.code === 0) {
                    this.getList()
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        formSubmit() {
            this.$refs['dataForm'].validate(valid => {
                if (valid) {
                    this.formLoading = true
                    let data = Object.assign({}, this.formData)
                    if (this.formName == 'add') {
                        logistics_asin_add(data).then(response => {
                            if (response.code == 0) {
                                this.hideForm()
                                this.getList()
                            } else {
                                this.$message.error(response.message)
                            }
                        }).catch(() => {
                            this.formLoading = false
                        }).finally(() => {
                            this.formLoading = false
                        })
                    } else {
                        data.id = this.formData.id
                        logistics_asin_edit(data).then(response => {
                            if (response.code == 0) {
                                this.hideForm()
                                this.getList()
                            } else {
                                this.$message.error(response.message)
                            }
                        }).catch(() => {
                            this.formLoading = false
                        }).finally(() => {
                            this.formLoading = false
                        })
                    }

                }
            })
        },
        // 删除
        handleDel(index, row) {
            if (row.id) {
                this.$confirm('确认删除该记录吗?', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        let para = {id: row.id}
                        this.deleteLoading = true
                        logistics_asin_deleted(para)
                            .then(response => {
                                this.deleteLoading = false
                                if (response.code) {
                                    this.$message.error(response.message)
                                    return false
                                }
                                this.$message.success('操作成功')
                                // 刷新数据
                                this.list.splice(index, 1)
                            })
                            .catch(() => {
                                this.deleteLoading = false
                            })
                    })
                    .catch(() => {
                        this.$message.info('取消删除')
                    })
            }
        }
    },
    mounted() {
        this.tableHeight =
            window.innerHeight - 140 - this.$refs.form.$el.offsetHeight
        const that = this
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == 'object') {
                    that.tableHeight =
                        window.innerHeight -
                        140 -
                        that.$refs.form.$el.offsetHeight
                }
            })()
        }
    },
    watch: {
        tableHeight(val) {
            this.tableHeight = val
        }
    },
    created() {
        this.getList()
    }
}
</script>

<style type="text/scss" lang="scss">
</style>
